module.exports = __webpack_public_path__ + "img/topindicator6.bb29a079.png";